//@ts-check
import React, { useCallback, useState } from "react";
import { userDuck } from "./UserDuck";
import { CustomInput } from "reactstrap";
import { useAppDispatch } from "src/utils/ReduxHooks";

const EmailSendingState = {
    none: 0,
    both: 1,
    onlyPrimary: 2,
    onlySecondary: 3
}


/**
 * 
 * @param {{userData: import('./User').UserDetailDto ,
 *  t: import('features/language/languageService').LanguageService}} props 
 */
const UserEmailSettings = ({ userData, t }) => {
    
    /** @type {import('redux').Dispatch<any>} */
    const dispatch = useAppDispatch();

    const [userTestEmailSettings, setUsertestEmailSettings] = useState(() => {

        // XX_mail, xx_mail2 are the names of the checkboxes bcause LastPass might intervene with names like mail
        return {
            xx_mail: userData.AllowTestResultEmails === EmailSendingState.onlyPrimary
                || userData.AllowTestResultEmails === EmailSendingState.both,
            xx_mail2: userData.Info.Email2?.Address !== ""
                && (userData.AllowTestResultEmails === EmailSendingState.onlySecondary
                    || userData.AllowTestResultEmails === EmailSendingState.both)
        };
    });

    const setTestMailSettings = useCallback(async (e) => {

        if (!e || !e.target) {
            return;
        }

        var newval = { ...userTestEmailSettings };
        newval[e.target.name] = e.target.checked;

        setUsertestEmailSettings(v => newval);

        var state = EmailSendingState.none;
        if (newval.xx_mail || newval.xx_mail2) {
            if (newval.xx_mail && newval.xx_mail2) {
                state = EmailSendingState.both;
            }
            else if (newval.xx_mail) {
                state = EmailSendingState.onlyPrimary;
            }
            else if (newval.xx_mail2) {
                state = EmailSendingState.onlySecondary;
            }

        }

        await dispatch( userDuck.updateEmailSettings(userData.Id, state) );

    }, [setUsertestEmailSettings, userData.Id, userTestEmailSettings, dispatch]);

    return (
        <div className=" pt-4">
            <div className="row mb-4">
                <div className="col">
                    <h3>{t.getText('emails.for.test.comments')}</h3>
                    
                    <CustomInput type="switch" id="xx_mail"
                        name="xx_mail"
                        label={userData.Info.Email.Address}
                        checked={userTestEmailSettings.xx_mail}
                        onChange={setTestMailSettings} />

                    {userData.Info && userData.Info.Email2?.Address &&
                        <CustomInput type="switch" id="xx_mail2"
                            name="xx_mail2"
                            label={userData.Info.Email2.Address}
                            checked={userTestEmailSettings.xx_mail2}
                            onChange={setTestMailSettings} />
                    }

                </div>
            </div>
        </div>
    )
}


export default UserEmailSettings;

